module.exports = __webpack_public_path__ + "static/media/Koffie-Freshbrew.cf4e287a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/categories/Koffie-Freshbrew.jpg
// module id = 319
// module chunks = 0